// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "email_sender_identity".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "email_sender_identity" table (1:1 with a DB row, on the wire). */
export const emailSenderIdentityAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    subdomain: z.string().nullable(),
    displayName: z.string().nullable(),
    replyTo: z.string().nullable(),
    status: z.string(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=emailSenderIdentity.js.map